import api from "@/apis/OptionAPI";
import Crud from "./crud-base";
var crud = new Crud("Option", api);
import httpClient from "@/apis/base/axios-httpclient";

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "OptionID",
      code: "OptionValue",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Cập nhật
   */
  async update(context, payload) {
    payload.ListEntity = payload.Entity;
    let res = await api.update(payload);
    if (res && res.Success) {
      if (res.Data) {
        //cập nhật danh sách
        context.commit("updateItem", res.Data);
      }
    }
    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
